import { configureStore, } from '@reduxjs/toolkit'
import type { TypedStartListening, TypedAddListener } from '@reduxjs/toolkit'
import rootReducer from "./reducer";
import i18n from './middlewares/i18n';
import storage from './middlewares/storage';
import feedback from './middlewares/feedback';
import redirect from './middlewares/redirect';
import postAuth from './middlewares/post-authentication';
// import navigation from './middlewares/navigation';
import { createRouterMiddleware, ReduxRouterState} from '@lagunovsky/redux-react-router'
import history from '../history';
import piwik from './middlewares/piwik';
import amplify from './middlewares/amplify';
import meta from './middlewares/meta';
import { production } from '../environments';

const routerMiddleware = createRouterMiddleware( history )

export const store = configureStore({
  reducer: rootReducer,
  middleware: ( getDefaultMiddleware ) => getDefaultMiddleware().prepend(
    // navigation.middleware,
    storage.middleware,
    postAuth.middleware,
    routerMiddleware,
    piwik.middleware,
    redirect.middleware,
    amplify.middleware,
    feedback.middleware,
    meta.middleware,
    i18n.middleware,
  ),
  devTools: !production ? true : false,
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export type AppStartListening = TypedStartListening<RootState, AppDispatch>

export default store;
